import {ApiClient} from '@hconnect/apiclient'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ShiftSummaryDocumentPayload} from '../types'

export const ShiftSummaryDocumentQueryKey = 'shift-summary-document'

type UseShiftSummaryDocumentParams = {
  plantId: string
  options?: UseMutationOptions<Blob, AxiosError, ShiftSummaryDocumentPayload>
}

export const useShiftSummaryDocument = ({plantId, options}: UseShiftSummaryDocumentParams) => {
  const path = `/shifthandover/${plantId}/shiftsummaryreport`

  return useMutation({
    mutationFn: async (data: ShiftSummaryDocumentPayload) => {
      const response = await ApiClient.axiosInstance.post(
        `${path}?reportLanguage=${data.reportLanguage}`,
        {
          ...data.timeRange,
          includeProductionVolumes: data.includeProductionVolumes
        },
        {
          responseType: 'blob'
        }
      )
      return response.data
    },
    ...options
  })
}
